import React from 'react'
import { ContainerFooter } from './styles'
import Button from '../Button'

interface iButtonProps {
    name: React.ReactNode | string;
    disabled?: boolean;
    className?: string;
    onClick: () => void;
    classNameButton?: string;
    to?: string;
}

const Footer: React.FC<iButtonProps> = ({ className, name, disabled, onClick, classNameButton, to }) => (
    <ContainerFooter className={className}>
        <Button className={`buttonwidth ${classNameButton}`} to={to} onClick={onClick} name={name} disabled={disabled} />
    </ContainerFooter>
)

export default Footer 